export default {
  API_RESOURCE: 'customers'
}
